export default __webpack_public_path__ + "static/media/level-3.0d27ba63.png";